import { Component } from '@angular/core';

import { AuthService } from '../../services/auth.service';

import { StorageService } from '../../services/storage.service';
import { PageNavigationService } from '../../services/page-navigation.service';
import { LayoutService } from '../../services/layout.service';

@Component({
	selector: 'Netlink-header',  //"Kowsalya: Text changed for NLT PRP portal development "
	templateUrl: 'header.component.html',
})
export class HeaderComponent{

    vDropdownVisibility: boolean;
    vDynamicPage: string;
    vShow: boolean;//Kowsalya//17112020

	constructor(
        private _authService: AuthService,
		private _storageService: StorageService,
		private _pageNavigationService: PageNavigationService,
        private _layoutService: LayoutService
	){}

    ngOnInit(){
        this.vDropdownVisibility = false;
        this.vDynamicPage = '';
        //Kowsalya//17112020
        this.vShow = false;
        var access;
        access = JSON.parse(this._storageService.getLocalItem('access'));
        //console.log(access);
       if(access != undefined && access != null ) { // Added by Arivoli for OTRS: 2020122269000038 defect fix. Date 05-Jan-2021
            if (this.actionChecking('MANINU', access) && this.actionChecking('MANEXU', access)) { // ADMN 
                this.vShow = true;
            }
            else if (this.actionChecking('PURPL', access) && this.actionChecking('PURNCE', access)){
                this.vShow = false;
            }
        } // Added by Arivoli for OTRS: 2020122269000038 defect fix. Date: 05-Jan-2021
         //Kowsalya//17112020
    }

    isHasLogin(){

        var hasLogin: boolean;
        hasLogin = this._storageService.getLocalItem('accessToken') == null || this._storageService.getLocalItem('accessToken') == '' ? false : true;

        if (hasLogin) {
            var access;
            try {
                access = JSON.parse(this._storageService.getLocalItem('access'));
            } catch (e) {
                access = null;
                this.vDynamicPage = 'login';
                return false;
            }

            if (this.actionChecking('MANINU', access) && this.actionChecking('MANEXU', access)&& !(this.actionChecking('MANPL', access))) { // ADMN 
                this.vDynamicPage = 'admin-report';
            }
            else if (this.actionChecking('MANPL', access) && !(this.actionChecking('MANINU', access)) && !(this.actionChecking('MANEXU', access))) //Kowsalya
            {
                this.vDynamicPage = 'plantmap-admin-all';
            }
            else {
                this.vDynamicPage = 'home';
            }
            return true;
        }
        else
        {
            this.vDynamicPage = 'login';
            return false;
        }
    }

    getHeaderVisibility() {
        return this._layoutService.vLayoutState.appHeader;
    }

    logout(){
        this._layoutService.isLogout = 1;//Kowsalya
        this._layoutService.tandc = false;//Kowsalya
        this._authService.logout();
        this.vDropdownVisibility = false;
    }

    showDropdown(){
        this.vDropdownVisibility = !this.vDropdownVisibility;
    }

    getName() {
        var personalData = this._storageService.getLocalItem('personalData');
        var personalName;
        try{
            personalName = JSON.parse(personalData).name;
        }catch(e){
            personalName = '';
        }
        return personalName;
    }

    getHeaderItemShow(){
        return this._layoutService.vHeader;
    }

    getLayoutState(){
        return this._layoutService.vLayoutState;
    }

    closeDropdown(){
        this.vDropdownVisibility = false;
    }

    isLoginPage() {
        if(this._layoutService.currentPage == "login-login") {
            return true;
        } else {
            return false;
        }
    }

    actionChecking(type, accesses) {
        for(var access of accesses){
            if(access == type){
                return true;
            }
        }
        return false;
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/shared/components/header/header.component.ts